import React, { useState, useEffect, useRef } from 'react';

const WelcomePage = () => {
  return(
    <>WelcomePage</>
  )
}

export default WelcomePage
